/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RWRCapabilitiesCrowdstrike { 
    /**
     * Enabled crowdstrike EDR regions.
     */
    enabled_crowdstrike_regions?: string;
    /**
     * Enabled VLCR AWS regions for crowdstrike.
     */
    enabled_vlcr_regions?: string;
    /**
     * The ARN of the OVA to be used by IRR.
     */
    ova_path?: string;
    /**
     * Enabled VLCR GCP regions for crowdstrike.
     */
    enabled_vlcr_gcp_regions?: string;
    /**
     * The GCP storage URI of the OVA to be used by IRR.
     */
    gcp_ova_path?: string;
    /**
     * Enable/ Disable Check for active IRR for allowing activating or de-activating crowdstrike.
     */
    requires_active_vcdr?: boolean;
    /**
     * Requires approval for deactivation.
     */
    requires_deactivation_approval?: boolean;
}

